import { render, staticRenderFns } from "./AddVendorRate.vue?vue&type=template&id=4c636acc&scoped=true&"
import script from "./AddVendorRate.vue?vue&type=script&lang=js&"
export * from "./AddVendorRate.vue?vue&type=script&lang=js&"
import style0 from "./AddVendorRate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddVendorRate.vue?vue&type=style&index=1&id=4c636acc&scoped=true&lang=css&"
import style2 from "./AddVendorRate.vue?vue&type=style&index=2&id=4c636acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c636acc",
  null
  
)

component.options.__file = "AddVendorRate.vue"
export default component.exports